import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@chakra-ui/react';

import { FeatherIcon } from '@izimi/components';

import { HeaderMobileNavigationMenu } from './HeaderMobileNavigationMenu';

export const HeaderMobileNavigationButton = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <HeaderMobileNavigationMenu isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <IconButton
        display={{ base: 'inline-flex', md: 'none' }}
        aria-label={isOpen ? t('navigation.hideNav') : t('navigation.showNav')}
        aria-expanded={isOpen}
        variant='menuIcon'
        background='transparent'
        icon={
          isOpen ? (
            <FeatherIcon name='x' stroke='neutral400' size={28} />
          ) : (
            <FeatherIcon name='menu' color='neutral400' />
          )
        }
        title={isOpen ? t('navigation.hideNav') : t('navigation.showNav')}
        onClick={() => setIsOpen(!isOpen)}
      />
    </>
  );
};
